import React from "react";
import ReactDOM from "react-dom";
import { loadCss } from "../../wea-tools/loadCss";

export default class ExtendsContainer extends React.Component {
  append() {
    const { children } = this.props;
    ReactDOM.unstable_renderSubtreeIntoContainer(
      this,
      children,
      this.container
    );
  }
  componentDidMount() {
    const { container, style, className, position = "last" } = this.props;
    this.container = document.createElement("div");
    this.container.className =
      className === void 0 ? "wea-rich-text-extents" : className;
    for (const key in style) {
      if (style.hasOwnProperty(key)) {
        this.container.style[key] = style[key];
      }
    }
    position === "first"
      ? container.insertBefore(this.container, container.firstChild)
      : container.appendChild(this.container);
    this.append();
    loadCss();
  }
  componentDidUpdate() {
    this.append();
  }
  componentWillUnmount() {
    const { container } = this.props;
    container && container.removeChild(this.container);
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/components/ExtendsContainer.js